import { request, requestPage } from '@/lib/apiClient';

export const subscriptionApi = {
  /** GET /admin/subscription -> overview, plans, instructions, recent payments */
  getOverview() {
    return request({ url: '/admin/subscription' });
  },

  /** POST /admin/subscription/manual-payment -> submit UTR and optional receipt */
  submitManualPayment(formData) {
    return request({
      url: '/admin/subscription/manual-payment',
      method: 'POST',
      data: formData,
    });
  },

  /** GET /admin/subscription/payments -> list recent payments for this shop */
  getPayments() {
    return request({ url: '/admin/subscription/payments' });
  },

  /** GET /platform/subscriptions -> operator list of all shop subscriptions */
  getPlatformSubscriptions({ page = 1, pageSize = 20, status, search } = {}) {
    return requestPage({
      url: '/platform/subscriptions',
      params: {
        page,
        limit: pageSize,
        ...(status ? { status } : {}),
        ...(search ? { search } : {}),
      },
    });
  },

  /** GET /platform/subscriptions/pending-payments -> operator pending list */
  getPendingPayments({ page = 1, pageSize = 20 } = {}) {
    return requestPage({
      url: '/platform/subscriptions/pending-payments',
      params: { page, limit: pageSize },
    });
  },

  /** GET /platform/subscriptions/plans -> every plan, inactive ones included */
  getPlans() {
    return request({ url: '/platform/subscriptions/plans' });
  },

  /** POST /platform/subscriptions/plans -> new plan shop admins can buy */
  createPlan(body) {
    return request({ url: '/platform/subscriptions/plans', method: 'POST', data: body });
  },

  /** PATCH /platform/subscriptions/plans/{id} -> edit, or switch off with is_active */
  updatePlan(planId, body) {
    return request({ url: `/platform/subscriptions/plans/${planId}`, method: 'PATCH', data: body });
  },

  /** GET /platform/subscriptions/payment-details -> UPI ID, bank account and QR */
  getPaymentDetails() {
    return request({ url: '/platform/subscriptions/payment-details' });
  },

  /** PUT /platform/subscriptions/payment-details -> replace the whole set */
  updatePaymentDetails(body) {
    return request({ url: '/platform/subscriptions/payment-details', method: 'PUT', data: body });
  },

  /** POST /platform/subscriptions/payment-details/qr -> { url }; save the details to use it */
  uploadPaymentQr(file) {
    const form = new FormData();
    form.append('file', file);
    return request({
      url: '/platform/subscriptions/payment-details/qr',
      method: 'POST',
      data: form,
    });
  },

  /** POST /platform/subscriptions/payments/{id}/verify -> APPROVE or REJECT */
  verifyPayment(paymentId, { decision, rejectionReason }) {
    return request({
      url: `/platform/subscriptions/payments/${paymentId}/verify`,
      method: 'POST',
      data: {
        decision,
        rejection_reason: rejectionReason || null,
      },
    });
  },

  /** POST /platform/subscriptions/{id}/extend -> Add days */
  extendSubscription(subscriptionId, days = 30) {
    return request({
      url: `/platform/subscriptions/${subscriptionId}/extend`,
      method: 'POST',
      params: { days },
    });
  },
};
